import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { adminApi, errMsg } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const r = await adminApi.post("/admin/login", { email, password });
      localStorage.setItem("bsk_admin_token", r.data.token);
      nav("/yonetim");
    } catch (er) {
      setErr(errMsg(er, "Giriş yapılamadı"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B1510] flex items-center justify-center px-4 relative grain">
      <form onSubmit={submit} className="relative z-10 w-full max-w-sm bg-[#FDFBF7] rounded-[2rem] p-8 shadow-2xl fade-up" data-testid="admin-login-form">
        <img src="/logo.jpg" alt="Başkent Sitesi logosu" className="w-16 h-16 rounded-full object-cover" />
        <h1 className="font-display text-3xl font-bold tracking-tight text-[#1B4332] mt-5">Yönetim Paneli</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">Başkent Sitesi yönetici girişi</p>
        <Input required type="email" placeholder="E-posta" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-xl bg-white mb-3" data-testid="admin-email-input" />
        <Input required type="password" placeholder="Şifre" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-xl bg-white" data-testid="admin-password-input" />
        {err && <p className="text-sm text-red-600 mt-3" data-testid="admin-login-error">{err}</p>}
        <Button type="submit" disabled={busy} className="w-full h-12 mt-5 rounded-full bg-[#1B4332] hover:bg-[#143326] font-bold" data-testid="admin-login-submit">
          {busy ? "Giriş yapılıyor..." : "Giriş Yap"}
        </Button>
        <Link to="/" className="block text-center text-xs text-slate-500 mt-5 hover:text-[#1B4332]" data-testid="admin-back-home">Siteye dön</Link>
      </form>
    </div>
  );
}
